function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnreachableException = function UnreachableException(value) {
  _classCallCheck(this, UnreachableException);

  return new Error("unreachable case: ".concat(JSON.stringify(value)));
};

export { UnreachableException as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/_util/unreachableException.js
// module id = 2309
// module chunks = 0